/* tslint:disable */
/* This is generated by ts_routes-rails */

export type ScalarType = string | number | boolean;

function $buildOptions(options: any, names: string[]): string {
  if (options) {
    let anchor = "";
    const q = [] as string[];
    for (const key of Object.keys(options)) {
      if (names.indexOf(key) !== -1) {
        // the key is already consumed
        continue;
      }

      const value = options[key];

      if (key === "anchor") {
        anchor = `#${$encode(value)}`;
      } else {
        $buildQuery(q, key, value);
      }
    }
    return (q.length > 0 ? "?" + q.join("&") : "") + anchor;
  } else {
    return "";
  }
}

function $buildQuery(q: string[], key: string, value: any) {
  if ($isScalarType(value)) {
    q.push(`${$encode(key)}=${$encode(value)}`);
  } else if (Array.isArray(value)) {
    for (const v of value) {
      $buildQuery(q, `${key}[]`, v);
    }
  } else if (value != null) {
    // i.e. non-null, non-scalar, non-array type
    for (const k of Object.keys(value)) {
      $buildQuery(q, `${key}[${k}]`, value[k]);
    }
  }
}

function $encode(value: any): string {
  return encodeURIComponent(value);
}

function $isScalarType(value: any): value is ScalarType {
  return (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  );
}

function $isPresent(value: any): boolean {
  return value != null && ("" + value).length > 0;
}

function $hasPresentOwnProperty(options: any, key: string): boolean {
  return options && options.hasOwnProperty(key) && $isPresent(options[key]);
}

/** /rails/mailers(.:format) */
export function railsMailersPath(options?: object): string {
  return "/" + "rails" + "/" + "mailers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/info/properties(.:format) */
export function railsInfoPropertiesPath(options?: object): string {
  return "/" + "rails" + "/" + "info" + "/" + "properties" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/info/routes(.:format) */
export function railsInfoRoutesPath(options?: object): string {
  return "/" + "rails" + "/" + "info" + "/" + "routes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/info(.:format) */
export function railsInfoPath(options?: object): string {
  return "/" + "rails" + "/" + "info" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/sign_in(.:format) */
export function newUserSessionPath(options?: object): string {
  return "/" + "users" + "/" + "sign_in" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/sign_in(.:format) */
export function userSessionPath(options?: object): string {
  return "/" + "users" + "/" + "sign_in" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/sign_out(.:format) */
export function destroyUserSessionPath(options?: object): string {
  return "/" + "users" + "/" + "sign_out" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/password/new(.:format) */
export function newUserPasswordPath(options?: object): string {
  return "/" + "users" + "/" + "password" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/password/edit(.:format) */
export function editUserPasswordPath(options?: object): string {
  return "/" + "users" + "/" + "password" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/password(.:format) */
export function userPasswordPath(options?: object): string {
  return "/" + "users" + "/" + "password" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /login(.:format) */
export function loginPath(options?: object): string {
  return "/" + "login" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /webhooks(.:format) */
export function webhooksPath(options?: object): string {
  return "/" + "webhooks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /webhooks/pledges(.:format) */
export function webhooksPledgesPath(options?: object): string {
  return "/" + "webhooks" + "/" + "pledges" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /webhooks/applications(.:format) */
export function webhooksApplicationsPath(options?: object): string {
  return "/" + "webhooks" + "/" + "applications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin(.:format) */
export function adminRootPath(options?: object): string {
  return "/" + "admin" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/comments/:id(.:format) */
export function adminCommentPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "comments" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/companies/:id/merge(.:format) */
export function mergeAdminCompanyPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "companies" + "/" + id + "/" + "merge" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/companies/:company_id/companies/comments(.:format) */
export function adminCompanyCompaniesCommentsPath(company_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "companies" + "/" + company_id + "/" + "companies" + "/" + "comments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["company_id","format"]);
}

/** /admin/companies(.:format) */
export function adminCompaniesPath(options?: object): string {
  return "/" + "admin" + "/" + "companies" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/companies/:id(.:format) */
export function adminCompanyPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "companies" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/candidates(.:format) */
export function adminCandidatesPath(options?: object): string {
  return "/" + "admin" + "/" + "candidates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/cycles/:id/make_current(.:format) */
export function makeCurrentAdminCyclePath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "cycles" + "/" + id + "/" + "make_current" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/cycles(.:format) */
export function adminCyclesPath(options?: object): string {
  return "/" + "admin" + "/" + "cycles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/form_fields/mappings(.:format) */
export function mappingsAdminFormFieldsPath(options?: object): string {
  return "/" + "admin" + "/" + "form_fields" + "/" + "mappings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/form_fields(.:format) */
export function adminFormFieldsPath(options?: object): string {
  return "/" + "admin" + "/" + "form_fields" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/candidate_emails/:id/send_test(.:format) */
export function sendTestAdminCandidateEmailPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "candidate_emails" + "/" + id + "/" + "send_test" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/candidate_emails/send_allocation_updates(.:format) */
export function sendAllocationUpdatesAdminCandidateEmailsPath(options?: object): string {
  return "/" + "admin" + "/" + "candidate_emails" + "/" + "send_allocation_updates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/candidate_emails/send_ineligible(.:format) */
export function sendIneligibleAdminCandidateEmailsPath(options?: object): string {
  return "/" + "admin" + "/" + "candidate_emails" + "/" + "send_ineligible" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/candidate_emails(.:format) */
export function adminCandidateEmailsPath(options?: object): string {
  return "/" + "admin" + "/" + "candidate_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/candidate_emails/:id(.:format) */
export function adminCandidateEmailPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "candidate_emails" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/employer_contacts/import(.:format) */
export function importAdminEmployerContactsPath(options?: object): string {
  return "/" + "admin" + "/" + "employer_contacts" + "/" + "import" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/employer_contacts/archive(.:format) */
export function archiveAdminEmployerContactsPath(options?: object): string {
  return "/" + "admin" + "/" + "employer_contacts" + "/" + "archive" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/employer_contacts/reactivate(.:format) */
export function reactivateAdminEmployerContactsPath(options?: object): string {
  return "/" + "admin" + "/" + "employer_contacts" + "/" + "reactivate" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/employer_contacts(.:format) */
export function adminEmployerContactsPath(options?: object): string {
  return "/" + "admin" + "/" + "employer_contacts" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/eligibility/rules(.:format) */
export function rulesAdminEligibilityPath(options?: object): string {
  return "/" + "admin" + "/" + "eligibility" + "/" + "rules" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/eligibility/recheck(.:format) */
export function recheckAdminEligibilityPath(options?: object): string {
  return "/" + "admin" + "/" + "eligibility" + "/" + "recheck" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/eligibility/bulk(.:format) */
export function bulkAdminEligibilityPath(options?: object): string {
  return "/" + "admin" + "/" + "eligibility" + "/" + "bulk" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/eligibility(.:format) */
export function adminEligibilityPath(options?: object): string {
  return "/" + "admin" + "/" + "eligibility" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/allocation_runs/:id/export(.:format) */
export function exportAdminAllocationRunPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "allocation_runs" + "/" + id + "/" + "export" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/allocation_runs(.:format) */
export function adminAllocationRunsPath(options?: object): string {
  return "/" + "admin" + "/" + "allocation_runs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/allocation_runs/:id(.:format) */
export function adminAllocationRunPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "allocation_runs" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/applications(.:format) */
export function adminGraphitiApplicationsPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "applications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/applications/new(.:format) */
export function newAdminGraphitiApplicationPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "applications" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/applications/:id/edit(.:format) */
export function editAdminGraphitiApplicationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "applications" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/applications/:id(.:format) */
export function adminGraphitiApplicationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "applications" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/allocation_applications(.:format) */
export function adminGraphitiAllocationApplicationsPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "allocation_applications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/allocation_applications/new(.:format) */
export function newAdminGraphitiAllocationApplicationPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "allocation_applications" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/allocation_applications/:id/edit(.:format) */
export function editAdminGraphitiAllocationApplicationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "allocation_applications" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/allocation_applications/:id(.:format) */
export function adminGraphitiAllocationApplicationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "allocation_applications" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/allocation_requests(.:format) */
export function adminGraphitiAllocationRequestsPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "allocation_requests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/allocation_requests/new(.:format) */
export function newAdminGraphitiAllocationRequestPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "allocation_requests" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/allocation_requests/:id/edit(.:format) */
export function editAdminGraphitiAllocationRequestPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "allocation_requests" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/allocation_requests/:id(.:format) */
export function adminGraphitiAllocationRequestPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "allocation_requests" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/allocation_runs(.:format) */
export function adminGraphitiAllocationRunsPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "allocation_runs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/allocation_runs/new(.:format) */
export function newAdminGraphitiAllocationRunPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "allocation_runs" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/allocation_runs/:id/edit(.:format) */
export function editAdminGraphitiAllocationRunPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "allocation_runs" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/allocation_runs/:id(.:format) */
export function adminGraphitiAllocationRunPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "allocation_runs" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/bulk_release_requests(.:format) */
export function adminGraphitiBulkReleaseRequestsPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "bulk_release_requests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/bulk_release_requests/new(.:format) */
export function newAdminGraphitiBulkReleaseRequestPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "bulk_release_requests" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/bulk_release_requests/:id/edit(.:format) */
export function editAdminGraphitiBulkReleaseRequestPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "bulk_release_requests" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/bulk_release_requests/:id(.:format) */
export function adminGraphitiBulkReleaseRequestPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "bulk_release_requests" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/candidates(.:format) */
export function adminGraphitiCandidatesPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "candidates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/candidates/new(.:format) */
export function newAdminGraphitiCandidatePath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "candidates" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/candidates/:id/edit(.:format) */
export function editAdminGraphitiCandidatePath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "candidates" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/candidates/:id(.:format) */
export function adminGraphitiCandidatePath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "candidates" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/companies(.:format) */
export function adminGraphitiCompaniesPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "companies" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/companies/new(.:format) */
export function newAdminGraphitiCompanyPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "companies" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/companies/:id/edit(.:format) */
export function editAdminGraphitiCompanyPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "companies" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/companies/:id(.:format) */
export function adminGraphitiCompanyPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "companies" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/companies_cycles(.:format) */
export function adminGraphitiCompaniesCyclesPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "companies_cycles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/companies_cycles/new(.:format) */
export function newAdminGraphitiCompaniesCyclePath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "companies_cycles" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/companies_cycles/:id/edit(.:format) */
export function editAdminGraphitiCompaniesCyclePath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "companies_cycles" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/companies_cycles/:id(.:format) */
export function adminGraphitiCompaniesCyclePath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "companies_cycles" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/company_cycle_informations(.:format) */
export function adminGraphitiCompanyCycleInformationsPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "company_cycle_informations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/company_cycle_informations/new(.:format) */
export function newAdminGraphitiCompanyCycleInformationPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "company_cycle_informations" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/company_cycle_informations/:id/edit(.:format) */
export function editAdminGraphitiCompanyCycleInformationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "company_cycle_informations" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/company_cycle_informations/:id(.:format) */
export function adminGraphitiCompanyCycleInformationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "company_cycle_informations" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/contacts(.:format) */
export function adminGraphitiContactsPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "contacts" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/contacts/new(.:format) */
export function newAdminGraphitiContactPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "contacts" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/contacts/:id/edit(.:format) */
export function editAdminGraphitiContactPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "contacts" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/contacts/:id(.:format) */
export function adminGraphitiContactPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "contacts" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/cycles(.:format) */
export function adminGraphitiCyclesPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "cycles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/cycles/new(.:format) */
export function newAdminGraphitiCyclePath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "cycles" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/cycles/:id/edit(.:format) */
export function editAdminGraphitiCyclePath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "cycles" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/cycles/:id(.:format) */
export function adminGraphitiCyclePath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "cycles" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/programmes(.:format) */
export function adminGraphitiProgrammesPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "programmes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/programmes/new(.:format) */
export function newAdminGraphitiProgrammePath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "programmes" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/programmes/:id/edit(.:format) */
export function editAdminGraphitiProgrammePath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "programmes" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/programmes/:id(.:format) */
export function adminGraphitiProgrammePath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "programmes" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/internships(.:format) */
export function adminGraphitiInternshipsPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "internships" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/internships/new(.:format) */
export function newAdminGraphitiInternshipPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "internships" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/internships/:id/edit(.:format) */
export function editAdminGraphitiInternshipPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "internships" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/internships/:id(.:format) */
export function adminGraphitiInternshipPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "internships" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/jobs(.:format) */
export function adminGraphitiJobsPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/jobs/new(.:format) */
export function newAdminGraphitiJobPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "jobs" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/jobs/:id/edit(.:format) */
export function editAdminGraphitiJobPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "jobs" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/jobs/:id(.:format) */
export function adminGraphitiJobPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "jobs" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/job_seekers(.:format) */
export function adminGraphitiJobSeekersPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "job_seekers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/job_seekers/new(.:format) */
export function newAdminGraphitiJobSeekerPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "job_seekers" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/job_seekers/:id/edit(.:format) */
export function editAdminGraphitiJobSeekerPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "job_seekers" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/job_seekers/:id(.:format) */
export function adminGraphitiJobSeekerPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "job_seekers" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/release_requests(.:format) */
export function adminGraphitiReleaseRequestsPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "release_requests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/release_requests/new(.:format) */
export function newAdminGraphitiReleaseRequestPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "release_requests" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/release_requests/:id/edit(.:format) */
export function editAdminGraphitiReleaseRequestPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "release_requests" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/release_requests/:id(.:format) */
export function adminGraphitiReleaseRequestPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "release_requests" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/reports(.:format) */
export function adminGraphitiReportsPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "reports" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/reports/new(.:format) */
export function newAdminGraphitiReportPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "reports" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/reports/:id/edit(.:format) */
export function editAdminGraphitiReportPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "reports" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/reports/:id(.:format) */
export function adminGraphitiReportPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "reports" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/report_templates(.:format) */
export function adminGraphitiReportTemplatesPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "report_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/report_templates/new(.:format) */
export function newAdminGraphitiReportTemplatePath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "report_templates" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/report_templates/:id/edit(.:format) */
export function editAdminGraphitiReportTemplatePath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "report_templates" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/report_templates/:id(.:format) */
export function adminGraphitiReportTemplatePath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "report_templates" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/universities(.:format) */
export function adminGraphitiUniversitiesPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "universities" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/universities/new(.:format) */
export function newAdminGraphitiUniversityPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "universities" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/universities/:id/edit(.:format) */
export function editAdminGraphitiUniversityPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "universities" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/universities/:id(.:format) */
export function adminGraphitiUniversityPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "universities" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/users(.:format) */
export function adminGraphitiUsersPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/users/new(.:format) */
export function newAdminGraphitiUserPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "users" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/users/:id/edit(.:format) */
export function editAdminGraphitiUserPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "users" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/users/:id(.:format) */
export function adminGraphitiUserPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "users" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/workstreams(.:format) */
export function adminGraphitiWorkstreamsPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "workstreams" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/workstreams/new(.:format) */
export function newAdminGraphitiWorkstreamPath(options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "workstreams" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/graphiti/workstreams/:id/edit(.:format) */
export function editAdminGraphitiWorkstreamPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "workstreams" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/graphiti/workstreams/:id(.:format) */
export function adminGraphitiWorkstreamPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "graphiti" + "/" + "workstreams" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/reports(.:format) */
export function adminReportsPath(options?: object): string {
  return "/" + "admin" + "/" + "reports" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/reports/:id(.:format) */
export function adminReportPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "reports" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/users(.:format) */
export function adminUsersPath(options?: object): string {
  return "/" + "admin" + "/" + "users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/programmes/:programme_id/release_requests/export(.:format) */
export function exportAdminProgrammeReleaseRequestsPath(programme_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "programmes" + "/" + programme_id + "/" + "release_requests" + "/" + "export" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["programme_id","format"]);
}

/** /admin/programmes/:programme_id/companies/:id(.:format) */
export function adminProgrammeCompanyPath(programme_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "programmes" + "/" + programme_id + "/" + "companies" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["programme_id","id","format"]);
}

/** /admin/programmes/:programme_id/companies_cycles/:id(.:format) */
export function adminProgrammeCompaniesCyclePath(programme_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "programmes" + "/" + programme_id + "/" + "companies_cycles" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["programme_id","id","format"]);
}

/** /admin/programmes/:programme_id/company_submissions/export(.:format) */
export function exportAdminProgrammeCompanySubmissionsPath(programme_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "programmes" + "/" + programme_id + "/" + "company_submissions" + "/" + "export" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["programme_id","format"]);
}

/** /admin/programmes/:programme_id/company_submissions(.:format) */
export function adminProgrammeCompanySubmissionsPath(programme_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "programmes" + "/" + programme_id + "/" + "company_submissions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["programme_id","format"]);
}

/** /admin/programmes/:programme_id/insights/internships/internships_by_workstream(.:format) */
export function internshipsByWorkstreamAdminProgrammeInsightsInternshipsPath(programme_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "programmes" + "/" + programme_id + "/" + "insights" + "/" + "internships" + "/" + "internships_by_workstream" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["programme_id","format"]);
}

/** /admin/programmes/:programme_id/book_building(.:format) */
export function adminProgrammeBookBuildingPath(programme_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "programmes" + "/" + programme_id + "/" + "book_building" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["programme_id","format"]);
}

/** /admin/programmes/:programme_id/recruitment_dashboard(.:format) */
export function adminProgrammeRecruitmentDashboardPath(programme_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "programmes" + "/" + programme_id + "/" + "recruitment_dashboard" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["programme_id","format"]);
}

/** /admin/programmes/:programme_id/settings/integrations(.:format) */
export function adminProgrammeSettingsIntegrationsPath(programme_id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "programmes" + "/" + programme_id + "/" + "settings" + "/" + "integrations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["programme_id","format"]);
}

/** /uploads(.:format) */
export function uploadsPath(options?: object): string {
  return "/" + "uploads" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/companies(.:format) */
export function apiV1CompaniesPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "companies" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/jobs(.:format) */
export function apiV1JobsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "jobs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/release_requests(.:format) */
export function apiV1ReleaseRequestsPath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "release_requests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /withdraw/:token(.:format) */
export function candidateWithdrawalPath(token: ScalarType, options?: object): string {
  return "/" + "withdraw" + "/" + token + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["token","format"]);
}

/** / */
export function rootPath(options?: object): string {
  return "/" + $buildOptions(options, []);
}

/** /rails/action_mailbox/postmark/inbound_emails(.:format) */
export function railsPostmarkInboundEmailsPath(options?: object): string {
  return "/" + "rails" + "/" + "action_mailbox" + "/" + "postmark" + "/" + "inbound_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/action_mailbox/relay/inbound_emails(.:format) */
export function railsRelayInboundEmailsPath(options?: object): string {
  return "/" + "rails" + "/" + "action_mailbox" + "/" + "relay" + "/" + "inbound_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/action_mailbox/sendgrid/inbound_emails(.:format) */
export function railsSendgridInboundEmailsPath(options?: object): string {
  return "/" + "rails" + "/" + "action_mailbox" + "/" + "sendgrid" + "/" + "inbound_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/action_mailbox/mandrill/inbound_emails(.:format) */
export function railsMandrillInboundHealthCheckPath(options?: object): string {
  return "/" + "rails" + "/" + "action_mailbox" + "/" + "mandrill" + "/" + "inbound_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/action_mailbox/mandrill/inbound_emails(.:format) */
export function railsMandrillInboundEmailsPath(options?: object): string {
  return "/" + "rails" + "/" + "action_mailbox" + "/" + "mandrill" + "/" + "inbound_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/action_mailbox/mailgun/inbound_emails/mime(.:format) */
export function railsMailgunInboundEmailsPath(options?: object): string {
  return "/" + "rails" + "/" + "action_mailbox" + "/" + "mailgun" + "/" + "inbound_emails" + "/" + "mime" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/conductor/action_mailbox/inbound_emails(.:format) */
export function railsConductorInboundEmailsPath(options?: object): string {
  return "/" + "rails" + "/" + "conductor" + "/" + "action_mailbox" + "/" + "inbound_emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/conductor/action_mailbox/inbound_emails/new(.:format) */
export function newRailsConductorInboundEmailPath(options?: object): string {
  return "/" + "rails" + "/" + "conductor" + "/" + "action_mailbox" + "/" + "inbound_emails" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/conductor/action_mailbox/inbound_emails/:id(.:format) */
export function railsConductorInboundEmailPath(id: ScalarType, options?: object): string {
  return "/" + "rails" + "/" + "conductor" + "/" + "action_mailbox" + "/" + "inbound_emails" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format) */
export function newRailsConductorInboundEmailSourcePath(options?: object): string {
  return "/" + "rails" + "/" + "conductor" + "/" + "action_mailbox" + "/" + "inbound_emails" + "/" + "sources" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/conductor/action_mailbox/inbound_emails/sources(.:format) */
export function railsConductorInboundEmailSourcesPath(options?: object): string {
  return "/" + "rails" + "/" + "conductor" + "/" + "action_mailbox" + "/" + "inbound_emails" + "/" + "sources" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format) */
export function railsConductorInboundEmailReroutePath(inbound_email_id: ScalarType, options?: object): string {
  return "/" + "rails" + "/" + "conductor" + "/" + "action_mailbox" + "/" + inbound_email_id + "/" + "reroute" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["inbound_email_id","format"]);
}

/** /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format) */
export function railsConductorInboundEmailIncineratePath(inbound_email_id: ScalarType, options?: object): string {
  return "/" + "rails" + "/" + "conductor" + "/" + "action_mailbox" + "/" + inbound_email_id + "/" + "incinerate" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["inbound_email_id","format"]);
}

/** /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format) */
export function railsServiceBlobPath(signed_id: ScalarType, filename: ScalarType[], options?: object): string {
  return "/" + "rails" + "/" + "active_storage" + "/" + "blobs" + "/" + "redirect" + "/" + signed_id + "/" + filename.map((part) => $encode(part)).join("/") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["signed_id","filename","format"]);
}

/** /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format) */
export function railsServiceBlobProxyPath(signed_id: ScalarType, filename: ScalarType[], options?: object): string {
  return "/" + "rails" + "/" + "active_storage" + "/" + "blobs" + "/" + "proxy" + "/" + signed_id + "/" + filename.map((part) => $encode(part)).join("/") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["signed_id","filename","format"]);
}

/** /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format) */
export function railsBlobRepresentationPath(signed_blob_id: ScalarType, variation_key: ScalarType, filename: ScalarType[], options?: object): string {
  return "/" + "rails" + "/" + "active_storage" + "/" + "representations" + "/" + "redirect" + "/" + signed_blob_id + "/" + variation_key + "/" + filename.map((part) => $encode(part)).join("/") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["signed_blob_id","variation_key","filename","format"]);
}

/** /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format) */
export function railsBlobRepresentationProxyPath(signed_blob_id: ScalarType, variation_key: ScalarType, filename: ScalarType[], options?: object): string {
  return "/" + "rails" + "/" + "active_storage" + "/" + "representations" + "/" + "proxy" + "/" + signed_blob_id + "/" + variation_key + "/" + filename.map((part) => $encode(part)).join("/") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["signed_blob_id","variation_key","filename","format"]);
}

/** /rails/active_storage/disk/:encoded_key/*filename(.:format) */
export function railsDiskServicePath(encoded_key: ScalarType, filename: ScalarType[], options?: object): string {
  return "/" + "rails" + "/" + "active_storage" + "/" + "disk" + "/" + encoded_key + "/" + filename.map((part) => $encode(part)).join("/") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["encoded_key","filename","format"]);
}

/** /rails/active_storage/disk/:encoded_token(.:format) */
export function updateRailsDiskServicePath(encoded_token: ScalarType, options?: object): string {
  return "/" + "rails" + "/" + "active_storage" + "/" + "disk" + "/" + encoded_token + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["encoded_token","format"]);
}

/** /rails/active_storage/direct_uploads(.:format) */
export function railsDirectUploadsPath(options?: object): string {
  return "/" + "rails" + "/" + "active_storage" + "/" + "direct_uploads" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}
